import { IconContent } from '@icons';

export const alertOctagon: IconContent = {
    md: '<path fill-rule="evenodd" d="M8.3 3.1h7.4l.1.1 5 5 .1.1v7.4l-.1.1-5 5-.1.1H8.3l-.1-.1-5-5-.1-.1V8.3l.1-.1 5-5 .1-.1Zm.4 1L4.1 8.7v6.6l4.6 4.6h6.6l4.6-4.6V8.7l-4.6-4.6H8.7Zm2.8 9.9V7h1v7h-1Zm0 1.5v1.2h1v-1.2h-1Z" clip-rule="evenodd"/>',
};
